module.exports = __webpack_public_path__ + "img/利润表.03f92b07.png";